import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Header, Button } from "semantic-ui-react";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Entity404 extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    copy: PropTypes.func.isRequired
  };

  render() {
    const { id, type, copy } = this.props;

    const entityType = type ? type : copy("entity_404.type");

    return (
      <Container>
        <Header as="h3">{`${entityType}: ${id}`}</Header>
        <SegmentMessage
          title={copy("entity_404.title")}
          message={copy("entity_404.body")}
          negative={true}
        />
        <Button as={LinkWithReset} to="/dashboard" className="float-right">
          {copy("entity_404.cta")}
        </Button>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(Entity404);
